import styled from "styled-components";

const Heading2Styles = styled.h2`
  font-style: normal;
  font-weight: ${({ theme }) => theme.typography.body.b3.weight};
  font-size: ${({ theme }) => theme.typography.body.b3.size};
  line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
  letter-spacing: 1px;
  color: ${({ theme }) => theme.colors.semantic.text.strong};
`;

const Heading2 = ({ children, className, style }) => (
  <Heading2Styles className={className} style={{ ...style }}>
    {children}
  </Heading2Styles>
);

export default Heading2;
